<div class="card options-card">
  <div class="card-header bp-card-header">
    <i class="fas fa-file-invoice payment-options-icon"></i>
    <p class="font-weight-light bp-text">Forms</p>
  </div>
  <div class="card-body">

        <button class="btn btn-link btn-block clearfix accordion-btn" >
          <!--<i *ngIf="!showPaperlessBilling" class="fas fa-angle-right fa-2x accordion-arrow"></i>
          <i *ngIf="showPaperlessBilling" class="fas fa-angle-down fa-2x accordion-arrow"></i>-->
          <div class="accordion-title-div pull-left font-weight-light bp-text bp-medium-text">Landlord Agreements</div>
        </button>
        <div class="container accordion-container">
          <div class="row">
            <div class="col-sm-4">
              <img style="width:23rem;" src="assets/LandlordAgreementForm.png" />
            </div>
            <div class="col-sm-8">
              <p class="bp-text bp-small-text tall-p">
                The Landlord Agreement Option is available to property owners,
                landlords, and management companies who agree to have the
                electric service automatically placed in their name for billing when
                a tenant vacates the premises. The electric service is not
                disconnected, and therefore a trip is not made to reconnect
                service for the landlord.
              </p>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-4"></div>
            <div class="col-sm-2">
              <input style="float:left;" class="btn btn-danger" type="button" value="APPLY ONLINE">
            </div>
            <div class="col-sm-6" style="padding-left:5%;">
              <input style="float:left;" class="btn btn-danger" type="button" value="DOWNLOAD FORM">
            </div>
          </div>
          </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/manage-forms/manage-forms.component.html